var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.systemConfig)?_c('div',{staticClass:"top-bar",style:({background:_vm.themeType === 4?'#F8F2EF':''})},[(_vm.themeType === 1)?_c('ThemeOne'):(_vm.themeType === 2)?_c('ThemeTwo'):(_vm.themeType === 3)?_c('ThemeThree'):(_vm.themeType === 4)?_c('ThemeFour'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }